import React, { useState, useRef, useEffect } from 'react'
import { Grid, LinearProgress, DialogTitle, DialogContent, DialogActions, Button, Dialog, FormControl, Box, Autocomplete, TextField, Typography } from '@mui/material'
import stylesheet from '../detail-container.stylesheet'
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined'
import { ClassNameMap, withStyles } from '@mui/styles'
import Draggable from 'react-draggable'
import DialogTitleHeaderComponent from '../common/dialog-title-header.component'

interface IProps {
  open: boolean
  item: any
  handleDialogClose: any
  handleSubmit: any
  classes: ClassNameMap
}

const AddProgramDialogComponent: React.FC<IProps> = ({ open, item, handleDialogClose, handleSubmit, classes }) => {
  const isAddPrRef = useRef(null) as any
  const [isLoadingPrg, setIsLoadingPrg] = useState(true)
  const [isSubmit, setIsSubmit] = useState(false)
  const [currprg, setCurrPrg] = useState<any>(() => {
    if (item?.programs) {
      return item.prgData?.find((p: any) => p.name === item.programs) || null
    }
    return null
  })

  useEffect(() => {
    setTimeout(function () {
      setIsLoadingPrg(false)
    }, 600)
  })

  const sortedPrgData = [...(item.prgData || [])].sort((a: any, b: any) => {
    const nameA = (a?.display_name?.trim() || '').toLowerCase()
    const nameB = (b?.display_name?.trim() || '').toLowerCase()
    return nameA < nameB ? -1 : 1
  })

  const renderAddProblem = () => {
    return (
      <FormControl className={classes.formControlStage}>
        <Autocomplete
          id={`${item.title}-select`}
          options={sortedPrgData}
          getOptionLabel={(option: any) => option?.display_name || ''}
          getOptionDisabled={(option: any) => option?.checked}
          value={currprg}
          onChange={(_event: any, newValue: any) => setCurrPrg(newValue)}
          disablePortal={false}
          className={classes.chipSearch}
          renderOption={(props, option: any) => (
            <Typography {...props} sx={{ padding: '0.2rem 0rem 0.2rem 0.5rem !important', fontSize: '0.65rem !important' }} className={classes.desc}>
              {option?.display_name}
              {option?.checked && <CheckCircleOutlineOutlinedIcon className={classes.programIcon} />}
            </Typography>
          )}
          renderInput={(params: any) => (
            <TextField
              {...params}
              sx={{ '& .MuiInputBase-input': { fontSize: '0.7rem !important' }, '& .MuiInputLabel-root': { fontSize: '0.7rem !important' } }}
              variant="standard"
              label={item?.label || 'Select'}
              placeholder=""
            />
          )}
          sx={{
            minWidth: '200px',
            '& .MuiAutocomplete-option.Mui-disabled': { opacity: 0.5, color: '#959292ff !important' },
          }}
        />
      </FormControl>
    )
  }

  const setSubmitData = () => {
    setIsSubmit(true)
    handleSubmit(currprg?.name)
  }

  return (
    <Draggable ref={isAddPrRef} defaultPosition={{ x: 0, y: 0 }} handle=".add-program-dialog">
      <Dialog
        id={item.title}
        fullWidth={true}
        maxWidth="sm"
        open={open}
        onClose={handleDialogClose}
        aria-labelledby={item.title}
        hideBackdrop
        disableScrollLock
        onKeyUp={(e) => {
          e.preventDefault()
          if (e.key === 'Enter' && !(!currprg || isSubmit)) setSubmitData()
        }}
        sx={{
          position: 'absolute',
          left: '15%',
          top: '20%',
        }}
      >
        <DialogTitle className={classes.addPatientQuestionHeaderSection} classes={{ root: 'add-program-dialog' }}>
          <DialogTitleHeaderComponent title={item?.title} handleDialogClose={handleDialogClose} />
        </DialogTitle>
        {isLoadingPrg && (
          <Box>
            <LinearProgress />{' '}
          </Box>
        )}

        <DialogContent className={classes.addPatientDialogContent}>
          <Box pt={3}>{renderAddProblem()}</Box>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={2} className={classes.containerPadding} justifyContent="flex-end">
            <Grid item>
              <Button variant="outlined" size="small" disabled={!currprg || isSubmit} onClick={setSubmitData} component="label" sx={{ '&.Mui-disabled': { opacity: 0.5, pointerEvents: 'none' } }}>
                Submit
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                size="small"
                disabled={isSubmit}
                onClick={() => {
                  setCurrPrg(null)
                  handleDialogClose()
                }}
                sx={{ '&.Mui-disabled': { opacity: 0.5, pointerEvents: 'none' } }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </Draggable>
  )
}

export default withStyles(stylesheet)(AddProgramDialogComponent)
